import { Directive, ElementRef, HostListener, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[checkTruncate]'
})
// credit to chatgpt (i mean co-pilot :D) thank u
export class CheckTruncateDirective implements AfterViewInit {
    @Output() isTruncated = new EventEmitter<boolean>();

    constructor(private el: ElementRef<HTMLElement>) { }

    ngAfterViewInit() {
        this.CheckTruncate();
    }

    @HostListener('window:resize')
    Resized() {
        this.CheckTruncate();
    }

    private CheckTruncate() {
        const element = this.el.nativeElement;
        const isTruncated = element.scrollWidth > element.clientWidth;
        this.isTruncated.emit(isTruncated);
    }
}